import React, { ComponentType, Context, ReactNode } from 'react';

export interface MainContentContextProps {
  appName?: string;
  PrimaryTitle?: ComponentType<{ children: ReactNode }>;
  SecondaryTitle?: ComponentType<{ children: ReactNode }>;
  contentWidth?: number;
  paddingTop: number;
}

const MainContentContext: Context<MainContentContextProps> = React.createContext({ paddingTop: 0 });

export default MainContentContext;
